module.exports = __webpack_public_path__ + "static/UBCLaunchPad-Info-dark-c947283bd69a4b800ea7395434095703.svg";